import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "feedback-container" }
const _hoisted_2 = { class: "fab__icon" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "feedback-form__header" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "feedback-form__actions" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["fab", { 'fab--expanded': _ctx.isExpanded }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpanded && _ctx.toggleExpanded(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isExpanded)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "💬"))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "✕"))
      ])
    ], 2),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "feedback-overlay",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
        }, [
          _createElementVNode("div", {
            class: "feedback-form",
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Send Feedback", -1)),
              _createElementVNode("button", {
                class: "feedback-form__close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
              }, "✕")
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFeedback && _ctx.submitFeedback(...args)), ["prevent"])),
              class: "feedback-form__content"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { for: "name" }, "Name (optional)", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "name",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                  type: "text",
                  placeholder: "Your name",
                  class: "form-input"
                }, null, 512), [
                  [_vModelText, _ctx.formData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { for: "email" }, "Email (optional)", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
                  type: "email",
                  placeholder: "your.email@example.com",
                  class: "form-input"
                }, null, 512), [
                  [_vModelText, _ctx.formData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { for: "type" }, "Feedback Type", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "type",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.type) = $event)),
                  class: "form-select"
                }, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("option", { value: "general" }, "General Feedback", -1),
                  _createElementVNode("option", { value: "bug" }, "Bug Report", -1),
                  _createElementVNode("option", { value: "feature" }, "Feature Request", -1),
                  _createElementVNode("option", { value: "support" }, "Support Request", -1)
                ]))], 512), [
                  [_vModelSelect, _ctx.formData.type]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "message" }, "Message *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "message",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.message) = $event)),
                  placeholder: "Tell us what you think...",
                  class: "form-textarea",
                  rows: "4",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.formData.message]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn--secondary",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                }, " Cancel "),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn--primary",
                  disabled: _ctx.isSubmitting
                }, _toDisplayString(_ctx.isSubmitting ? 'Sending...' : 'Send Feedback'), 9, _hoisted_11)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}